import React, { useEffect, useState } from "react";
import { Alert } from "@domestika-dev/prudencio/dist/atoms/Alert";
import { Button } from "@domestika-dev/prudencio/dist/atoms/Buttons";
import { IconForm } from "@domestika-dev/prudencio/dist/atoms/Icon";
import { BellHeavy, Close } from "@domestika-dev/prudencio/dist/atoms/Icons";
import { Flex } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { LinkText, Text } from "@domestika-dev/prudencio/dist/atoms/Typography";
import { FormattedMessage } from "react-intl";
import { pushNotification } from "../../../../../js/utils/pushNotification";
import When from "../../../../common/When";

export const NotificationsAlert = () => {
  const [hasUserClosedAlert, setUserClosedAlert] = useState();
  const [isNotificationsGranted, setNotificationsGranted] = useState();

  const onRequestPermission = () => {
    window.Notification.requestPermission((permission) => {
      const granted = pushNotification.isPermissionGranted({ permission });
      const denied = pushNotification.isPermissionDenied({ permission });
      setNotificationsGranted(granted);
      setUserClosedAlert(denied);
      pushNotification.updateSettings({ settings: { granted, closed: denied } });
    });
  };

  const onClose = () => {
    pushNotification.updateSettings({ settings: { granted: false, closed: true } });
    setUserClosedAlert(true);
  };

  useEffect(() => {
    if (!pushNotification.isEnabled()) {
      return;
    }

    setNotificationsGranted(
      pushNotification.isPermissionGranted({ permission: window.Notification.permission })
    );

    const hasUserPreviouslyClosed = pushNotification.getSettings()?.closed;
    const hasUserDeniedPermission = pushNotification.isPermissionDenied({
      permission: window.Notification.permission,
    });

    setUserClosedAlert(hasUserPreviouslyClosed || hasUserDeniedPermission);
  }, []);

  useEffect(() => {
    if (isNotificationsGranted) {
      pushNotification.register();
    }
  }, [isNotificationsGranted]);

  return (
    <When
      condition={pushNotification.isEnabled() && !isNotificationsGranted && !hasUserClosedAlert}
    >
      {() => (
        <Alert type="warning" isClosable={false} marginBottom={5}>
          <Flex justifyContent="space-between" alignItems="center" flexWrap="nowrap">
            <Flex justifyContent="flex-start" alignItems="center" flexWrap="nowrap">
              <IconForm size="medium" marginRight={4}>
                <BellHeavy />
              </IconForm>
              <Flex flexWrap="wrap">
                <Text size="micro" marginRight={2}>
                  <FormattedMessage id="live_sessions.notification.permissions_title" />
                </Text>
                <Flex paddingBottom={1}>
                  <Button buttonType="text" size="none" action={onRequestPermission}>
                    <LinkText underline size="micro" fontWeight="medium">
                      <FormattedMessage id="live_sessions.notification.permissions_cta" />
                    </LinkText>
                  </Button>
                </Flex>
              </Flex>
            </Flex>
            <Button buttonType="text" size="medium" action={onClose}>
              <IconForm size="small">
                <Close />
              </IconForm>
            </Button>
          </Flex>
        </Alert>
      )}
    </When>
  );
};

export default NotificationsAlert;
